import * as React from 'react';
const Protector = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#003594"
        d="M12 15.615c.229 0 .42-.077.575-.232a.781.781 0 0 0 .233-.575.782.782 0 0 0-.232-.576A.782.782 0 0 0 12 14a.782.782 0 0 0-.575.232.782.782 0 0 0-.233.576c0 .229.078.42.232.575a.782.782 0 0 0 .576.232Zm-.75-3.403h1.5V7.385h-1.5v4.827ZM12 21.48c-2.163-.59-3.954-1.863-5.372-3.82-1.419-1.956-2.128-4.143-2.128-6.56V5.345L12 2.54l7.5 2.807V11.1c0 2.418-.71 4.605-2.128 6.562-1.418 1.956-3.21 3.229-5.372 3.819Zm0-1.58c1.733-.55 3.167-1.65 4.3-3.3s1.7-3.484 1.7-5.5V6.374l-6-2.24-6 2.24V11.1c0 2.017.567 3.85 1.7 5.5s2.567 2.75 4.3 3.3Z"
      />
    </g>
  </svg>
);
export default Protector;
